import request from '@/utils/request';
// 获取文安列表
export function getProductDescApi(data) {
  return request({
    url: '/ecom/ai/getProductDesc',
    method: 'post',
    data
  })
}
// 修改文案
export function updateProductDescApi(data) {
  return request({
    url: '/ecom/ai/updateProductDesc',
    method: 'post',
    data
  })
}
// 添加文案
export function insertProductDescApi(data) {
  return request({
    url: '/ecom/ai/insertProductDesc',
    method: 'post',
    data
  })
}